import { el } from "./dom";

export const STRAD_URL = "https://www.strad.global";

// The masthead brand. The STRAD mark links OUT to the firm site in a new tab;
// the "Trust Lens" wordmark is the in-app home control (returns to Assemble), so
// the outbound link is never the only way back into the app.
export function renderBrand(onHome: () => void): HTMLElement {
  return el(
    "span",
    { class: "brand" },
    el("a", {
      class: "brand__logo",
      href: STRAD_URL,
      attrs: {
        role: "img",
        "aria-label": "STRAD, opens strad.global in a new tab",
        target: "_blank",
        rel: "noopener noreferrer",
      },
    }),
    el("button", {
      class: "wordmark__product brand__home",
      type: "button",
      text: "Trust Lens",
      attrs: { "aria-label": "Trust Lens, return to the start" },
      on: { click: onHome },
    }),
  );
}
